module.exports = __webpack_public_path__ + "8d06a325e0408d5806efc53c4e89916b.pdf";